<template>
  <span class="dot" :class="colorClass"></span>
</template>
<script>

export default {
  components: {
  },
  props: ['color'],
  computed: {
    colorClass () {
      return `bg-${this.color}`
    },
  },
}
</script>

<style lang="scss" scoped>

.dot {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
}

</style>
